import { WorkerAction } from '../../framework/workerAction';

export default {
  navigate: new WorkerAction({ name: 'FRONT_NAVIGATE_TO_ANALYTICS' }, {}),
};
